import React, { useState, useEffect } from 'react';
import heroImage from '../assets/images/jetblack-bg.png';

const ReservationScreen = () => {
  // Animación para la tarjeta (contenedor del iframe)
  const [cardAnimation, setCardAnimation] = useState({
    transform: 'translateY(70px) scale(0.9)',
    opacity: 0,
  });

  // Animación para el iframe (efecto escalonado)
  const [iframeAnimation, setIframeAnimation] = useState({
    transform: 'translateY(40px) scale(0.9)',
    opacity: 0,
  });

  // Al montar el componente, se dispara la animación para mostrar la tarjeta
  useEffect(() => {
    const timeout = setTimeout(() => {
      setCardAnimation({
        transform: 'translateY(0) scale(1)',
        opacity: 1,
      });
    }, 200);
    return () => clearTimeout(timeout);
  }, []);

  // Animación del iframe con un retraso adicional para efecto escalonado
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIframeAnimation({
        transform: 'translateY(0) scale(1)',
        opacity: 1,
      });
    }, 400);
    return () => clearTimeout(timeout);
  }, []);

  // Estilos en línea para el contenedor principal
  const containerStyle = {
    padding: '0',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f7f7f7',
    minHeight: '100vh',
    overflowX: 'hidden',
    position: 'relative',
  };

  /* Sección Hero:
     - Div con backgroundImage, overlay y contenido alineado a la izquierda.
     - Solo se muestra el título, de forma estética.
  */
  const heroSectionStyle = {
    position: 'relative',
    width: '100%',
    height: '450px',
    backgroundImage: `url(${heroImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '30px',
  };

  // Overlay para oscurecer la imagen ligeramente (opacidad 0.2)
  const heroOverlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  };

  // Contenido del hero: solo el título, alineado a la izquierda
  const heroContentStyle = {
    position: 'relative',
    zIndex: 1,
    textAlign: 'left',
    color: '#ffffff',
    textShadow: '1px 1px 3px rgba(0,0,0,0.5)',
  };

  // Se ajusta el título para que sea más sutil: menor tamaño, peso y letter-spacing
  const headingStyle = {
    fontSize: '3rem',       // Reducido de 3.5rem a 3rem
    fontWeight: '600',      // Menos "fuerte" que 900
    margin: '0',
    textTransform: 'uppercase',
    letterSpacing: '2px',   // Menos espaciado para suavizar el efecto
  };

  // Estilo de la tarjeta que contendrá el formulario (iframe)
  const cardStyle = {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '25px',
    maxWidth: '90%',
    margin: '80px auto 80px auto',
    transition: 'transform 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55), opacity 0.7s ease',
    boxShadow: '0 15px 40px rgba(0, 0, 0, 0.3), 0 10px 30px rgba(0, 0, 0, 0.25)',
    ...cardAnimation,
  };

  // Contenedor para el iframe (overflow hidden para recortar contenido superior)
  const iframeWrapperStyle = {
    overflow: 'hidden',
    borderRadius: '8px',
  };

  // Estilo del iframe, con un marginTop negativo mayor para recortar más la parte superior
  const iframeStyle = {
    width: '100%',
    height: '600px',
    border: 'none',
    transition: 'transform 0.7s ease, opacity 0.7s ease',
    marginTop: '-120px',
    ...iframeAnimation,
  };

  return (
    <div style={containerStyle}>
      {/* Sección Hero */}
      <div style={heroSectionStyle}>
        <div style={heroOverlayStyle}></div>
        <div style={heroContentStyle}>
          <h1 style={headingStyle}>Reserve Your Ride</h1>
        </div>
      </div>

      {/* Tarjeta con el formulario de reserva */}
      <div style={cardStyle}>
        <div style={iframeWrapperStyle}>
          <iframe
            src="https://bookridesonline.com/book/?dbaid=a0QxYhwasvAMbYgsQXPG0g%3d%3d"
            title="Booking Form"
            style={iframeStyle}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ReservationScreen;
